import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const Page404Container = lazy(() =>
  import(/* webpackChunkName: "Error404Container" */ '../containers/Page404Container')
);

const Page404 = lazy(() =>
  import(/* webpackChunkName: "Error404Page" */ '../presentational/Page404')
);

export default () => {
  return [
    <Route exact path="/pagina-nao-encontrada" component={Page404} key="route-404" />,
    <Route component={Page404Container} key="container-404" />,
  ];
};
